import {ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {NotificationService} from 'src/app/core/services/notification.service';
import {ToastrService} from 'ngx-toastr';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {Message} from 'src/app/core/class/message';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {DocumentService} from 'src/app/core/services/document.service';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {BehaviorSubject} from 'rxjs';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {CommonService} from 'src/app/core/services/common.service';
import {ConfirmSignOtpComponent} from '../../confirm-sign-otp/confirm-sign-otp.component';
import {ApiService} from 'src/app/core/services/api.service';
import {AlertComponent} from 'src/app/shared/components/alert/alert.component';
import {ContractService} from 'src/app/core/services/contract.service';
import {EnumSignMethod} from "../../../../../../../core/constants/contract";
import {ApproveProgressComponent} from '../approve-progress/approve-progress.component';
import {
  imageConfigRenderId,
  imageConfigViewScaleId
} from '../../sign-flow-document/image-sign-config/image-sign-config.component';
import {SignatureConfig} from '../../sign-flow-document/signature-config.model';
import {switchMap, tap} from 'rxjs/operators';
import {ImageGenerateService} from "../../../../../../../core/services/image-generate.service";

// import { readUint16 } from 'src/assets/js/pdf.worker';

declare function signHash(comp, hashBase64): any;

declare function initPlugin(comp): any;

declare function initPluginCertificateNormal(comp, contracts: any): any;


@Component({
  selector: 'app-sign-document-waiting-confirm',
  templateUrl: './sign-document-waiting-confirm.component.html',
  styleUrls: ['./sign-document-waiting-confirm.component.scss']
})
export class signDocumentWaitingConfirmComponent implements OnInit, OnDestroy {
  // @ts-ignore
  @ViewChild('SignImageConfig3', {static: true, read: ElementRef}) domRenderImage: ElementRef
  scopeType = this.commonService.checkEnterpriseType() ? 2 : 1;
  signConfig: SignatureConfig = SignatureConfig.build();
  /**
   * stop sign action.
   */
  public static CONFIRM_ACTION = 'confirm';

  public static CONFIRM_ACTION_NON_CERTIFICATE = 'confirm2';

  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  /**
   * sign slot of document.
   */
  public static SIGN_SLOT = 'slot';

  public static DLECINE_SLOT = 'decline slot';

  /**
   * sign single of document.
   */
  public static SIGN_SINGLE = 'single';

  /**
   * sign with server.
   */
  public static SIGN_SERVER = 0;

  /**
   * sign with usb token.
   */
  public static SIGN_USB_TOKEN = 1;

  /**
   * Sign with sim ca.
   */
  public static SIGN_SIM_CA = 2;

  /**
   * Sign with hsm.
   */
  public static SIGN_OTP = 3;

  /**
   * Sign with hsm.
   */
  public static SIGN_HSM = 4;

  public static DOCUMENT_UPLOAD = 1;

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  public signMultiType = new BehaviorSubject<number>(null);

  /**
   * sign type.
   */
  signType: string;

  /**
   * data single sign.
   */
  dataSignSingle: any;

  /**
   * data sign slot.
   */
  dataSignSlot: any;

  /**
   * Certificate Id
   */
  certificate: any;

  /**
   * selected cert.
   */
  selectedCert: any;

  /**
   * dialog signed.
   */
  dialogSign: any;

  /**
   * Model certificate
   */
  certificates: any;

  /**
   * Type certificate
   */
  typeCertificate: number;

  /**
   * Model request create hash
   */
  sign = {
    contractId: '',
    digitalCertificateId: '',
    digitalCertificateDetailId: '',
    certificate: '',
    path: '',
    signature: '',
    signPdf: '',
    phoneNumber: '',
    serialNumber: '',
    image: null
  };

  enterpriseByService = {
    warningSmsTotalMoney: false,
  };

  /**
   * variable check form change
   */
  isFormChanging = false;

  checkFocus = true;
  show = true;

  /**
   * Check submit succee
   */
  success = false;

  isHsmPermission: boolean = false

  /**
   * Get enterpriseId
   */
  enterpriseId = localStorage.getItem('enterpriseId');
  cloudCaMultiSignThreshold = localStorage.getItem('cloudCaMultiSignThreshold');
  usbTokenMultiSignThreshold = localStorage.getItem('usbTokenMultiSignThreshold');

  linkDownSignPlugin = (os ?: string) => {
    let OSName = "Unknown OS";
    if (navigator.appVersion.indexOf("Win") != -1) OSName = "WINDOWS";
    if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MACOS";
    if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
    if (navigator.appVersion.indexOf("Linux") != -1) OSName = "LINUX";


    return this.apiService.getBaseUrl() + `/file/download-last-version?os=${OSName}&typeFile=${OSName === "WINDOWS" ? 'exe' : OSName === "LINUX" ? 'deb' : 'pkg'}`;
  };

  columnsToDisplay = ['issuedTo', 'taxCode', 'phoneNumber', 'expireDate'];
  columnsToDisplayCA = ['issuedTo', 'taxCode', 'phoneNumber', 'expireDate', 'hasTransSaved'];

  /**
   *
   */
  @BlockUI() blockUI: NgBlockUI;
  userType: any;
  signTypes = EnumSignMethod;

  constructor(
    private cd: ChangeDetectorRef,
    private contractService: ContractService,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    private commonService: CommonService,
    private apiService: ApiService,
    private digitalCertificateService: DigitalCertificateService,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<signDocumentWaitingConfirmComponent>,
    private signDocumentService: SignDocumentService,
    private imageGenerateService: ImageGenerateService,
    @Inject(MAT_DIALOG_DATA) public data: {
      type: string,
      document: any,
      documentTypeId?: number,
      documentEnterpriseId: string,
      documentEntity: any,
    }
  ) {
    if (data.type === signDocumentWaitingConfirmComponent.SIGN_SLOT) {
      this.dataSignSlot = data.document;
    } else {
      this.dataSignSingle = data.document;
    }

    this.signType = data.type;

    dialogRef.disableClose = false;
    this.userType = localStorage.getItem('userType');
  }

  /**
   * Init compon
   */
  async ngOnInit() {
    this.scopeType = this.commonService.checkEnterpriseType() ? 2 : 1;
    this.notificationService.subscribeErrorService();
    this.getCertificates();
    await this.getUserConfig().toPromise();
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  getMessageCloudCaThreshold() {
    return this.message.getMessage('search_form.cloud_ca_multi_sign_threshold').replace('{0}', this.cloudCaMultiSignThreshold);
  }

  getMessageUsbTokenThreshold() {
    return this.message.getMessage('search_form.usb_token_multi_sign_threshold').replace('{0}', this.usbTokenMultiSignThreshold);
  }

  /**
   * Process sign document with signatures server
   */
  processSignServer() {
    if (!this.data.documentEntity.submitedToA && this.data.documentEntity.status === 0
      || (!this.data.documentEntity.submitedToB && (this.data.documentEntity.status === 4 || this.data.documentEntity.status === 8) && Number(this.userType) !== 5)) {
      this.signDocumentService.signatureServerDirectly(this.sign).subscribe(rs => {
        this.onSignSuccess();
      });
    } else {
      this.signDocumentService.signatureServer(this.sign).subscribe(rs => {
        this.onSignSuccess();
      });
    }
  }

  getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService() {
    this.contractService.getDataSmsContractQuantityByEnterpriseId(this.data.documentEnterpriseId).subscribe(
      response => {
        if (Object.keys(response.data).length !== 0 && response.data.constructor === Object) {
          this.enterpriseByService.warningSmsTotalMoney = response.data.warningSmsTotalMoney;
        }
      }
    );
  }

  /**
   * Process sign document with HSM
   */
  processSignHSM() {
    this.signDocumentService.signHSM(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  /**
   * Process sign document with Sim CA
   */
  processSignSimCA() {
    this.sign.phoneNumber = this.certificate.phoneNumber;
    this.sign.serialNumber = this.certificate.serialNumber;
    if (!this.data.documentEntity.submitedToA && this.data.documentEntity.status === 0
      || (!this.data.documentEntity.submitedToB && (this.data.documentEntity.status === 4 || this.data.documentEntity.status === 8) && Number(this.userType) !== 5)) {
      this.signDocumentService.signSimCADirectly(this.sign).subscribe(rs => {
        this.onSignSuccess();
      });
    } else {
      this.signDocumentService.signSimCA(this.sign).subscribe(rs => {
        this.onSignSuccess();
      });
    }
  }

  onChangeType() {
    this.selectedCert = null;
  }

  /**
   * Process after signing success
   */
  private onSignSuccess() {
    this.toastr.success(this.message.getMessage('messages.sign_success'));
    this.success = true;
    this.dialogRef.close();
  }

  /**
   * Compare Serianumber and create Hash
   */
  createHash(certUserBase64: string) {
    if (this.dataSignSingle !== null) {
      this.sign.certificate = certUserBase64;
      this.documentService.createHash(this.sign).subscribe(rs => {
        this.sign.path = rs.data.path;
        this.sign.signPdf = rs.data.signPdf;
        // fix sonar
        // this.sign.signature = signHash(this, rs.data.hash);
        if (this.sign.signature) {
          if (!this.data.documentEntity.submitedToA && this.data.documentEntity.status === 0
            // tslint:disable-next-line:max-line-length
            || (!this.data.documentEntity.submitedToB && (this.data.documentEntity.status === 4 || this.data.documentEntity.status === 8) && Number(this.userType) !== 5)) {
            this.signUsbDirectly(this.sign);
          } else {
            this.signUsb(this.sign);
          }
        }
      });
    }
  }

  /**
   * Sign Usb
   */
  signUsb(certificate: any) {
    this.documentService.signUsb(certificate).subscribe(() => {
      this.onSignSuccess();
    });
  }

  signUsbDirectly(certificate: any) {
    this.documentService.signUsbDirectly(certificate).subscribe(() => {
      this.onSignSuccess();
    });
  }

  /**
   * Click cancel.
   */
  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '30%',
        data: this.message.getMessage('messages.confirm_change_data')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Get list cerfiticate
   */
  getCertificates() {
    this.digitalCertificateService.getCertificates(this.enterpriseId).subscribe(rs => {
      let displayCerts = [];

      if (rs && rs.data) {
        if (this.signType === signDocumentWaitingConfirmComponent.SIGN_SLOT) {
          rs.data.forEach(cert => {
            let check = false;
            cert.listCert.forEach(item => {
              if (Number(item.typeCertificate) === EnumSignMethod.CLOUD_CA
                || Number(item.typeCertificate) === EnumSignMethod.SIGN_USB_TOKEN) {
                check = true;
              }
            });

            if (check) {
              displayCerts.push(cert);
            }
          });
        } else {
          // Check condition is document upload then not allow sign OTP
          // if (this.data.documentTypeId === signDocumentWaitingConfirmComponent.DOCUMENT_UPLOAD) {
          //   rs.data.forEach(cert => {
          //     let check = false;
          //     cert.listCert.forEach(item => {
          //       if (Number(item.typeCertificate) !== signDocumentWaitingConfirmComponent.SIGN_OTP) {
          //         check = true;
          //       }
          //     });
          //
          //     if (check) {
          //       displayCerts.push(cert);
          //     }
          //   });
          // } else {
          //   displayCerts = rs.data;
          // }

          // rs.data.forEach(x => {
          //   x.listCert.forEach(item => {
          //     if (item.phoneNumber !== '' && item.phoneNumber !== undefined) {
          //       item.phoneNumber = item.phoneNumber.replace("84", "0");
          //     }
          //     return item;
          //   });
          //
          //   return x;
          // })

          displayCerts = rs.data;
        }
      }

      this.certificates = displayCerts;

      // Select first certificate
      this.typeCertificate = this.certificates[0].type;
      this.selectedCert = this.certificates[0].listCert[0];
      this.setIssueTo(this.selectedCert);
      this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
        if (res && res.success) {
          this.isHsmPermission = res.data.enableHsm
        }
      })
    });
  }

  /**
   * Show error form certificate.js
   * @param msg message
   */
  showErrMsg(msg) {
    this.toastr.error(msg);
  }

  /**
   * Show error form certificate.js
   * @param msg message
   */
  showErrMsgTransle(msg) {
    this.blockUI.stop();
    this.toastr.error(this.message.getMessage(msg));
  }

  createATag(link: string, title: string) {
    return '<a target="_blank" href="' + link + '">' + title + '</a>';
  }

  /**
   * Show error format form certificate.js
   * @param msg message
   */
  showErrMsgTransleFormat(msg) {
    this.blockUI.stop();
    const link = this.linkDownSignPlugin();
    console.log("here we go ", link);

    if (msg === "messages.not_initPlugin") {
      msg = "messages.initPlugin_faile"
    }

    this.dialog.open(AlertComponent, {
      width: '370px',
      data: this.message.getMessage(msg)
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>'
        // + '<br/ >' + this.message.getMessage('messages.download_plugin_sign_os') + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
        // + '<a target="_blank" href="' + link + '"> '+
        + this.createATag(this.linkDownSignPlugin('WINDOWS'), "Windows, ") + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
      // + '</a>'
      // + '<br/ >' + this.message.getMessage('messages.download_plugin_sign_os') +
    });
  }

  /**
   * Click on cancel button.
   */
  onClickCancelButton() {
    if (this.signType === signDocumentWaitingConfirmComponent.SIGN_SINGLE) {
      this.onNoClick();
    } else {
      this.actions.next(signDocumentWaitingConfirmComponent.CLOSE_ACTION);
    }
  }

  /**
   * Click on confirm button.
   */
  async onClickConfirmButton() {
    // getdate + get config
    await this.getUserConfig().toPromise();
    this.cd.detectChanges();
    const elId = document.getElementById("SignImageConfig3");
    if (!elId) {
      return;
    }
    // const blob = await htmlToImage.toPng(elId).then((url) => {
    //   return url
    // });
    // const newFile = blob.replace(/^data:image\/[a-z]+;base64,/, "") || null;
    let blob = null;
    try {
      let imageSize = this.setSizeFrameImage();
      blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();

    } catch (e) {
      console.log(e);
      try {
        let imageSize = this.setSizeFrameImage();
        blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
      } catch (e) {
        console.log(e);
      }
    }

    if (!blob) {
      this.toastr.error(this.message.getMessage('messages.error_proccessing'));
      return;
    }


    const imageBase64 = await this.commonService.getBase64(blob) as string;
    const newFile = imageBase64.replace(/^data:image\/[a-z]+;base64,/, "") || null;

    setTimeout(() => {
      if (this.signType === signDocumentWaitingConfirmComponent.SIGN_SINGLE) {
        if (this.dataSignSingle !== null && this.dataSignSingle.signAll == undefined) {
          this.sign.contractId = this.dataSignSingle;
          this.certificate = this.selectedCert;
          this.sign.digitalCertificateId = this.certificate.id;
          this.sign.digitalCertificateDetailId = this.certificate.idDetail;
          // Sign with signatures server 0
          if (this.certificate.typeCertificate === signDocumentWaitingConfirmComponent.SIGN_SERVER) {
            //check hsm permission
            this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
              if (res.data.enableHsm) {
                this.processSignServer();
              } else {
                this.toastr.error(this.message.getMessage('messages.not_hsm_permission'))
              }
            })
          }

          // Sign with Usb Token
          if (this.certificate.typeCertificate === signDocumentWaitingConfirmComponent.SIGN_USB_TOKEN) {
            this.blockUI.start('');
            initPlugin(this);
          }

          // Sign with SIM CA
          if (this.certificate.typeCertificate === signDocumentWaitingConfirmComponent.SIGN_SIM_CA) {
            this.processSignSimCA();
          }

          // Sign with OTP
          if (this.certificate.typeCertificate === signDocumentWaitingConfirmComponent.SIGN_OTP) {
            this.processSignOTP();
          }

          // Sign with HSM
          if (this.certificate.typeCertificate === signDocumentWaitingConfirmComponent.SIGN_HSM) {
            this.processSignHSM();
          }
        } else {
          this.dialogRef.close();
          // console.log("this.dataSignSingle", this.dataSignSingle);
          this.dialog.open(ApproveProgressComponent, {
            width: '80%',
            data: this.dataSignSingle
          });
        }
      } else if (this.signType === signDocumentWaitingConfirmComponent.SIGN_SLOT) {
        if (!this.selectedCert.imagePath) {
          this.documentService.systemSignImage.next(newFile)
        } else {
          this.documentService.systemSignImage.next(null)
        }
        if (this.selectedCert.typeCertificate === signDocumentWaitingConfirmComponent.SIGN_SERVER) {
          //check hsm permission
          this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
            if (res.data.enableHsm) {
              this.actions.next(signDocumentWaitingConfirmComponent.CONFIRM_ACTION);
            } else {
              this.toastr.error(this.message.getMessage('messages.not_hsm_permission'))
            }
          })
        } else {
          if (!this.selectedCert.imagePath) {
            this.documentService.systemSignImage.next(newFile)
          } else {
            this.documentService.systemSignImage.next(null)
          }
          this.actions.next(signDocumentWaitingConfirmComponent.CONFIRM_ACTION);
        }


      }
    }, 400);


  }

  /**
   * Open dialog confirm code for sign OTP
   */
  processSignOTP() {
    this.signDocumentService.generateTransaction(this.sign.contractId, this.selectedCert.phoneNumber, null).subscribe(rs => {
      this.openDialogConfirmSignOTP(rs.data);
    });
    // if (!this.data.documentEntity.submitedToA && this.data.documentEntity.status === 1
    //   // tslint:disable-next-line:max-line-length
    //   || (!this.data.documentEntity.submitedToB && (this.data.documentEntity.status === 4 || this.data.documentEntity.status === 8) && Number(this.userType) !== 5)) {
    //   this.signDocumentService.generateTransactionDirectly(this.sign.contractId, this.selectedCert.phoneNumber).subscribe(rs => {
    //     this.openDialogConfirmSignOTP(rs.data);
    //   });
    // } else {
    //   this.signDocumentService.generateTransaction(this.sign.contractId, this.selectedCert.phoneNumber).subscribe(rs => {
    //     this.openDialogConfirmSignOTP(rs.data);
    //   });
    // }
  }

  /**
   * Open dialog confirm code for sign OTP
   */
  openDialogConfirmSignOTP(transactionId: string) {
    const dialogRef = this.dialog.open(ConfirmSignOtpComponent, {
      width: '40%',
      data: {
        documentId: this.sign.contractId,
        transaction: transactionId,
        selectedPhone: this.selectedCert.phoneNumber
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (dialogRef.componentInstance.success) {
        this.toastr.success(this.message.getMessage('messages.sign_success'));
        this.success = true;
        this.dialogRef.close();
      }
    });
  }

  getConfigKeyList(): string[] {
    return Object.keys(this.signConfig);
  }

  getUserConfig() {
    return this.signDocumentService.getUserConfigAsync()
      .pipe(tap(res => {
          if (res.success && res.data) {
            for (const key in this.signConfig) {
              this.signConfig[key].enabled = res.data[key] || false;
            }

            this.signConfig.address.value = res.data['addressDetail'] || '';
            this.signConfig.position.value = res.data['positionDetail'] || '';
            this.signConfig.confirmBy.value = res.data['signature'] || '';
            this.signConfig.fontFamily.value = res.data['fontFamily'] || '';
            this.signConfig.fontWeight.value = res.data['fontWeight'] || '';
            this.signConfig.fontStyle.value = res.data['fontStyle'] || '';
            this.signConfig.signatureImageBase64.value = res.data['signatureImageBase64'] || '';
            this.signConfig.signatureImageName.value = res.data['signatureImageName'] || '';
            this.signConfig.signaturePosition.value = res.data['signaturePosition'] || '';
            this.signConfig.signatureRatio.value = res.data['signatureRatio'] || '';

            this.signConfig.fontFamily.enabled = false;
            this.signConfig.fontWeight.enabled = false;
            this.signConfig.fontStyle.enabled = false;
            this.signConfig.signatureImageBase64.enabled = false;
            this.signConfig.signatureImageName.enabled = false;
            this.signConfig.signaturePosition.enabled = false;
            this.signConfig.signatureRatio.enabled = false;
            this.signConfig.contentPosition.value = res.data['contentPosition'];
            this.signConfig.contentPosition.enabled = false;
          }
        }),
        switchMap(() => {
          return this.signDocumentService.getDateAsync()
        })
      ).pipe(
        tap(res => {
          if (res.success) {
            this.signConfig.signingTime.value = res.data.date;

            this.cd.detectChanges();
            setTimeout(() => {
              this.signDocumentService.setFontSize(imageConfigViewScaleId);
              this.signDocumentService.setFontSize(imageConfigRenderId);
            }, 100);
          }
        })
      )
  }

  showConfig(key: string): boolean {
    if (key === 'greenTick') {
      return false
    }

    if (this.selectedCert.typeCertificate !== 3) {
      if (key === 'phoneNumber') {
        this.signConfig.phoneNumber.enabled = false;
        return false;
      }
      if (key === 'confirmBy') {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
    } else {

      if (key === 'confirmBy' && this.scopeType !== 2) {
        this.signConfig.confirmBy.enabled = true;
        return true;
      } else if (key === 'confirmBy' && this.scopeType === 2) {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
    }

    return this.signConfig[key].enabled;
  }

  setIssueTo(cert) {
    this.signConfig.enterpriseName.value = cert.issuedTo;
  }

  setSizeFrameImage() {
    switch (this.signConfig.signaturePosition.value) {
      case 'left':
      case 'right':
        return {
          width: '370px',
          height: '136px'
        };
      case 'top':
      case 'bottom':
        return {
          width: '300px',
          height: '237px'
        };

      default:
        return {
          width: '300px',
          height: '136px'
        };
    }
  }
}
